import { render, staticRenderFns } from "./data-abstract.vue?vue&type=template&id=2662998c&scoped=true"
import script from "./data-abstract.vue?vue&type=script&lang=js"
export * from "./data-abstract.vue?vue&type=script&lang=js"
import style0 from "./data-abstract.vue?vue&type=style&index=0&id=2662998c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662998c",
  null
  
)

export default component.exports